import {Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {NotificationService} from "../../services/notification/notification.service";
import {Subscription} from "rxjs";
import {MessageItem} from "../../services/notification/message.item";
import {unsubscribe} from "../../libs/utils/epic.utils";
import {NgbToast} from "@ng-bootstrap/ng-bootstrap";

import {IconComponent} from "../../libs/icon/icon.component";
import {TranslatePipe} from "@ngx-translate/core";

interface Toast {
  message: MessageItem;
  classname?: string;
  delay: number;
}

@Component({
  selector: 'acc-toast',
  imports: [
    NgbToast,
    IconComponent,
    TranslatePipe
  ],
  templateUrl: './toast.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './toast.component.css'
})
export class ToastComponent implements OnInit, OnDestroy {

  protected toasts: Toast[] = [];

  private readonly subs: Subscription[] = [];
  private readonly defaultDelay = 5000;
  private readonly errorDelay = 30000;

  private readonly notificationService = inject(NotificationService);

  ngOnInit(): void {
    this.subs.push(this.notificationService.getMessage()
      .subscribe((m) => this.showMessage(m)));
  }

  ngOnDestroy(): void {
    unsubscribe(this.subs);
  }

  protected removeToast(toast: Toast): void {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  private showMessage(message: MessageItem): void {
    let classname = '';
    let delay = this.defaultDelay;
    if (message.error) {
      classname = 'bg-danger text-light';
      delay = this.errorDelay;
    } else if (message.success) {
      classname = 'bg-success text-light';
    }
    this.toasts.push({message, classname, delay});
  }
}
